import { styled as a, Box as f, useMediaQuery as x } from "@mui/material";
import y from "./DownloadButton.js";
import k from "./DownloadLastUpdate.js";
import w from "../../temp-lib/components/share/generic/AnimatedBox.js";
import * as B from "ramda";
import { jsxs as g, jsx as n } from "react/jsx-runtime";
const D = a(w)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: flex-start;
`, $ = a(f)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${(t) => t.theme.breakpoints.up("res480")} {
    gap: 18px;
  }
  ${(t) => t.theme.breakpoints.down("res480")} {
    gap: 6px;
  }
`, A = (t) => {
  const {
    analytic: i,
    className: p,
    infoBackground: l,
    infoList: e
  } = t, {
    emitById: m,
    event: s
  } = i, c = x((r) => r.breakpoints.up("res1024")) ? [e.slice(0, 4), e.slice(4)] : [e];
  return /* @__PURE__ */ g(D, {
    in: !0,
    className: p,
    children: [/* @__PURE__ */ n(k, {
      background: l,
      infoList: e
    }), c.map((r, d) => {
      const u = d;
      return /* @__PURE__ */ n($, {
        children: r.map((o) => /* @__PURE__ */ n(y, {
          analytic: m ? `${s}#${B.toLower(o.platform.type)}` : {
            event: s,
            value: o.platform.type
          },
          info: o
        }, `store_${o.platform.type}`))
      }, u);
    })]
  });
};
export {
  A as default
};
//# sourceMappingURL=DownloadButtons.js.map
